import { render, staticRenderFns } from "./ReferralsPage.vue?vue&type=template&id=8b82ed1a&scoped=true"
import script from "./ReferralsPage.vue?vue&type=script&lang=js"
export * from "./ReferralsPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralsPage.vue?vue&type=style&index=0&id=8b82ed1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b82ed1a",
  null
  
)

export default component.exports